export const MY_TASK_REQUEST = 'MY_TASK_REQUEST'
export const MY_TASK_RECEIVE = 'MY_TASK_RECEIVE'
export const MY_TASK_ERROR = 'MY_TASK_ERROR'
export const MY_TASK_INVALIDATE = 'MY_TASK_INVALIDATE'

export const MY_TASK_UPDATE_REQUEST = 'MY_TASK_UPDATE_REQUEST'
export const MY_TASK_UPDATE_RECEIVE = 'MY_TASK_UPDATE_RECEIVE'
export const MY_TASK_UPDATE_ERROR = 'MY_TASK_UPDATE_ERROR'



// WEBPACK FOOTER //
// ./src/store/myTask/actionTypes.js